// Module
var code = `<div class="container">
	<div class="row">
		<div class="col-12 col-sm-8 offset-sm-2 col-md-9 offset-md-3">
			<div class="card">
				<div class="card-header">
					<span class="card-title h4"> About</span>
				</div>
				<div class="card-body">
					<h2>
						<span>JumboTRON</span>
						<small>{{ \$ctrl.version | jumbotronVersion }}</small>
					</h2>
					<br>
					<h5>{{ \$ctrl.currentDateTime }}</h5>
				</div>
			</div>
		</div>
	</div>
</div>
`;
// Exports
export default code;